import React, { useEffect, useState } from "react";
import { Input, Button, Alert, Card, message } from "antd";
import startCase from "lodash/startCase";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import ButtonLoader from "../ButtonLoader";
import UserLocations from "../Locations/UserLocations";

const schema = yup.object().shape({
  first_name: yup.string().required("First Name is required"),
  last_name: yup.string().required("Last Name is required"),
});

const MyProfileForm = () => {
  const [loading, setLoading] = useState(true);
  const [showErrors, setShowErrors] = useState(false);
  const [errorsMessage, setErrorsMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [userData, setUserData] = useState(null);
  const [userLocations, setUserLocations] = useState([]);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const fetchUser = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/my-profile`
      );
      const editFormData = {
        ...response.data.data,
      };
      setUserData(editFormData);
      setUserLocations(editFormData.user_locations);
      reset(editFormData);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const onSubmitUser = async (data) => {
    const finalFormData = {
      first_name: data.first_name.trim(),
      last_name: data.last_name.trim(),
    };
    setSubmitting(true);
    let newFormData = finalFormData;
    const url = `${process.env.REACT_APP_BASE_URL}/api/update-profile`;

    try {
      const response = await axios.put(url, newFormData);
      // Reset form after successful submission
      reset(newFormData);
      const userData = response.data.data;
      const token = response.data.token;
      localStorage.setItem("userData", JSON.stringify(userData));
      localStorage.setItem("token", token);
      window.dispatchEvent(new Event("userDataUpdated"));
      setSubmitting(false);
      setShowErrors(false);
      message.success("Profile updated successfully");
    } catch (error) {
      if (error.response && error.response.status > 300) {
        const errorData = error.response.data.message;
        // const errorField = error.response.data.field;
        console.log(errorData);
        // setShowErrors(false);
        setErrorsMessage(errorData);
        setShowErrors(true);
        setTimeout(() => {
          setShowErrors(false);
        }, 3000);

        setSubmitting(false);
      } else {
        console.error("Error:", error);
      }
    }
  };

  return (
    <Card className="col-md-4">
      {" "}
      {loading ? (
        <ButtonLoader wrapperClass={`min-h-50`} />
      ) : (
        <>
          {showErrors && (
            <>
              <div className="col-sm-12 mb-3">
                <Alert message={errorsMessage} type="error" closeIcon={false} />
              </div>
            </>
          )}
          <form onSubmit={handleSubmit(onSubmitUser)}>
            <div className="mb-3">
              <label className="form-label fw-bold">
                First Name <span className="text-danger">*</span>
              </label>
              <Controller
                name="first_name"
                control={control}
                render={({ field }) => <Input {...field} />}
              />
              {errors.first_name && (
                <div className="text-danger small">
                  {errors.first_name.message}
                </div>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">
                Last Name <span className="text-danger">*</span>
              </label>
              <Controller
                name="last_name"
                control={control}
                render={({ field }) => <Input {...field} />}
              />
              {errors.last_name && (
                <div className="text-danger small">
                  {errors.last_name.message}
                </div>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">
                <strong>Username: </strong>
                {userData.username}
              </label>
            </div>

            <div className="mb-3">
              <label className="form-label">
                <strong>Role:</strong> {startCase(userData.role_name)}
              </label>
            </div>

            <div className="mb-3">
              <label className="form-label">
                <strong>Location(s):</strong>
              </label>
              <br />
              <UserLocations userLocations={userLocations} />
            </div>

            <Button type="primary" htmlType="submit" disabled={submitting}>
              {!submitting ? "Update" : <ButtonLoader text="Submitting..." />}
            </Button>
          </form>
        </>
      )}
    </Card>
  );
};

export default MyProfileForm;
